/**
 * Created by Ning Jiang on 2021-06-09.
 */

import {TombstoneRipSymbol} from "./TombstoneRipSymbol";
import {TombstoneRipSymbolState} from "./TombstoneRipSymbolConfig";
import {MathHelper} from "../../core/utils/MathHelper";
import {TombstoneRip} from "../TombstoneRip";
import {gsap, TimelineLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TombstoneRipGameMode} from "../gameflow/TombstoneRipGameMode";

export class TombstoneRipSingleWild extends TombstoneRipSymbol {

    private _randomDisplayIndex:number;
    private _landingSpine:PIXI.spine.Spine;

    constructor(symbolName:string, reelId:number, initState:TombstoneRipSymbolState) {
        super(symbolName, reelId, initState);
    }

    protected initAnimation() {
        this._randomDisplayIndex = MathHelper.randomNumberInRange(1, 5);
        super.initAnimation();
    }

    protected updateLayers() {
        super.updateLayers();
        if(this._landingSpine) {
            this.addChild(this._landingSpine);
        }
        if(this._scatterFrame) {
            this.addChild(this._scatterFrame);
        }
        if(this._rip) {
            this.addChild(this._rip);
        }
    }

    protected getStateTexture(state?:TombstoneRipSymbolState):PIXI.Texture[] {
        let texturePath = `${this.symbolName}/${this.symbolName}`;
        if(this.symbolSize > 1 && !this.symbolName.includes("D")) {
            texturePath += `_S${this.symbolSize}`;
        }
        if(state === TombstoneRipSymbolState.SPIN) {
            texturePath += `_${state}`;
        }

        return TombstoneRip.assetLoader.getTextures(`${texturePath}_${this._randomDisplayIndex}`);
    }

    // this will only happen on reel5
    protected getStateColorChangeAnimation(tint:number, tintSaturation:number, tintDuration:number):TimelineLite {
        const tl = super.getStateColorChangeAnimation(tint, tintSaturation, tintDuration);
        if(this._landingSpine && this._landingSpine.visible) {
            tl.add(() => {this._landingSpine.tint = tint}, 0);
        }

        return tl;
    }

    protected addSplitSymbolAnimation(tl:TimelineLite, oldSymbolSize:number, type:number) {
        if(this.symbolName === "W0D") {
            // This will actually never happen.
            return;
        }
        super.addSplitSymbolAnimation(tl, oldSymbolSize, type);
        if(this._landingSpine) {
            tl.add(gsap.to(this._landingSpine, {
                duration : 0.5, alpha : 0, onComplete : () => {
                    this._landingSpine.visible = false;
                }
            }), this._splitSplashDelay);
        }
        if(TombstoneRip.model.parsedGameData.mode === GameMode.FREESPIN ||
            TombstoneRip.model.parsedGameData.mode === TombstoneRipGameMode.FREESPIN_SUPER) {
            tl.add(() => TombstoneRip.multiplier.addMultiplier(oldSymbolSize, `W0Splitting on reel${this.reelId}`), this._splitSplashDelay);
        }
    }

    public playLanding(init:boolean = false):TimelineLite {
        if(!this._landingSpine) {
            this._landingSpine = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset(`W0Landing`));
            this._landingSpine.autoUpdate = true;
            this._landingSpine.position.set(this._centerPosition.x, this._centerPosition.y);
            this._landingSpine.tint = this.getStateTint();
        }
        const landingTl = new TimelineLite({paused : true});
        landingTl.add(new SpineTween(this._landingSpine, 0, `${this.symbolName}landing`));

        const tl = new TimelineLite();
        tl.add([
            () => this.updateLayers(),
            () => landingTl.play()
        ]);
        if(!init && (TombstoneRip.model.parsedGameData.mode === GameMode.FREESPIN ||
            TombstoneRip.model.parsedGameData.mode === TombstoneRipGameMode.FREESPIN_SUPER)) {
            tl.add(() => TombstoneRip.multiplier.addMultiplier(1, `W0Landing on reel${this.reelId}`));
        }
        tl.add(gsap.to(this, {duration : 0.01}));
        return tl;
    }
}